import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';

import './utils/Polyfills';
import { history, store } from './store';
import App from './App';
// import styles
import './styles/index.css';
import './styles/form.css';
import './styles/site-general.css';
import './styles/variables.css';
import './styles/animations.css';
import './styles/hidden.css';

import { unregister } from './registerServiceWorker';
// import { initTheme } from './utils/Theme';

/*
 * Before the first render, not inside a component: applying the theme in React
 * means the browser paints the light one and then swaps, which is a white flash
 * on every load for anyone using dark.
 *
 * Held back for now. Without this call no data-theme attribute is ever set, so
 * the dark block in variables.css matches nothing and the app is light for
 * everyone - including anyone who already switched while it was on.
 */
// initTheme();

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <App />
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root'),
);
unregister();



// WEBPACK FOOTER //
// ./src/index.jsx